import { createFeatureSelector, createSelector } from "@ngrx/store";
import { messageType } from "src/app/enums";
import { IMessage } from "src/app/models";
import { mainState } from "src/app/state/app.reducer";
import { Guid } from "guid-typescript";


export class Message implements IMessage {
  id: Guid;
  constructor(public message: string,public subMessage:string, public severity: messageType) {
    this.id =  Guid.create();
  }
}

export class InfoMessage implements IMessage {
  id: Guid;
  severity: messageType;
  
  constructor(public message: string,public subMessage: string ) {
    this.id = Guid.create();
    this.severity = messageType.Info;
  }
}

export class WarningMessage implements IMessage {
  id: Guid;
  severity: messageType;
  
  constructor(public message: string,public subMessage: string ) {
    this.id = Guid.create();
    this.severity = messageType.Warning;
  }
}

export class ErrorMessage implements IMessage {
  id: Guid;
  severity: messageType;
  
  constructor(public message: string,public subMessage: string ) {
    this.id = Guid.create();
    this.severity = messageType.Error;
  }
}

const getUserFeatureState = createFeatureSelector<mainState>('mainState');

export const getMessages = createSelector(
  getUserFeatureState,
  state => state.messages
);
